var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy350(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77.6 128.1",
    style: {
      enableBackground: "new 0 0 77.6 128.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFC3C8"
    },
    d: "M77.6,7.5c0-4.2-3.4-7.5-7.5-7.5H38.8H7.6C3.4,0,0,3.4,0,7.5C0,7.5,0,64,0,70.1 c0.1,7.6,3.9,11.5,8,17c4.9,6.5,30.3,41.1,30.3,41.1l0.5-0.7l0.5,0.7c0,0,25.4-34.6,30.3-41.1c4.1-5.5,7.9-9.3,8-17 C77.7,64,77.6,7.5,77.6,7.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M14.2,8.6c-3.3,0-5.9,2.6-5.9,5.9v49.2c0,3.3,2.6,5.9,5.9,5.9h49.2c3.3,0,5.9-2.6,5.9-5.9V14.5 c0-3.3-2.6-5.9-5.9-5.9H14.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAF00"
    },
    d: "M61.7,39.1c0-0.7-0.1-1.5-0.2-2.2H50c-0.6,0-1.1,0.2-1.5,0.6c-0.4,0.4-0.6,0.9-0.6,1.5 s0.2,1.1,0.6,1.5c0.4,0.4,0.9,0.6,1.5,0.6h11.5C61.6,40.6,61.7,39.9,61.7,39.1 M56.6,35.4h4.5c-0.6-1.8-1.6-3.5-2.8-4.8 c-2.1-2.2-5-3.6-8.3-3.6c-3.8,0-7.2,1.9-9.3,4.9l0,0c-0.5,0.6-1,1.4-1.3,1.9c-0.6,0.9-1.8,3.4-2.4,4.6c-0.2,0.4-0.3,0.6-0.3,0.6 l0,0c0,0,0,0,0,0l0,0l0,0c-0.1,0.1-0.4,0.8-0.9,1.6c-0.5,0.9-1.2,2-2,3.1l0,0l0,0c-1.4,1.9-3.5,3.1-6,3.1c-2.1,0-3.9-0.9-5.3-2.3 c-1.4-1.4-2.2-3.4-2.2-5.5s0.8-4.1,2.2-5.5c1.4-1.4,3.2-2.3,5.3-2.3c2.5,0,4.6,1.2,6,3.1l0,0l0,0c0.8,1.1,1.5,2.2,2,3.1l2.3-4.4 c-0.3-0.4-0.6-0.9-0.9-1.3l0,0l0,0c-2.1-3-5.5-4.9-9.3-4.9c-3.2,0-6.1,1.4-8.3,3.6c-2.1,2.2-3.4,5.2-3.4,8.6s1.3,6.4,3.4,8.6 c2.1,2.2,5,3.6,8.3,3.6c3.8,0,7.2-1.9,9.3-4.9l0,0c0.5-0.7,1-1.4,1.4-2.1c0.7-1.2,2-3.8,2.6-5c0-0.1,0.4-0.8,0.9-1.7 c0.5-0.9,1.2-2,2-3.1l0,0l0,0l0,0c1.4-1.9,3.6-3.1,6-3.1c2.1,0,3.9,0.9,5.3,2.3C55.8,34.1,56.2,34.7,56.6,35.4 M42,40.7l-2.3,4.4 c0.3,0.4,0.6,0.9,0.9,1.3l0,0c2.1,3,5.5,4.9,9.3,4.9c3.2,0,6.1-1.4,8.3-3.6c1.3-1.3,2.3-3,2.8-4.8h-4.5c-0.3,0.6-0.8,1.2-1.3,1.8 c-1.4,1.4-3.2,2.3-5.3,2.3c-2.5,0-4.6-1.2-6-3.1l0,0l0,0l0,0C43.2,42.7,42.5,41.6,42,40.7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "lamps"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "pozadie"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy350);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-350.8ff7685d06f567811e5fb90280d363ba.svg";
export { ForwardRef as ReactComponent };